import {
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  NavRight,
  Link,
  f7,
} from 'framework7-react';
import '../styles/login.css';
import '@styles/change-password.css';
import { useEffect, useState } from 'react';
import { getCurrentUser, getDocument, updateDocument } from '../firebase';

function AccountNamePage() {
  const [name, setName] = useState('');

  useEffect(() => {
    const fetchName = async () => {
      console.log('fetchName called');
      const user = await getCurrentUser();
      if (!user) {
        console.log('fetchName: no authenticated user');
        return;
      }

      try {
        console.log(`Fetching name for users/${user.uid}`);
        const snap = await getDocument(`users/${user.uid}`);
        console.log('Name document fetched', { exists: snap.exists(), data: snap.data() });
        if (snap.exists()) {
          const data = snap.data() as { fullName?: string };
          if (data.fullName) setName(data.fullName);
        }
      } catch (err) {
        console.error('Error fetching user info', err);
      }
    };

    fetchName();
  }, []);

  const handleSave = async () => {
    if (!name.trim()) {
      f7.dialog.alert('Name cannot be empty.');
      return;
    }
    const user = await getCurrentUser();
    if (!user) return;

    f7.dialog.preloader('Saving...');
    try {
      await updateDocument(`users/${user.uid}`, { fullName: name.trim() });

      try {
        const info = localStorage.getItem('userInfo');
        const data = info ? JSON.parse(info) : {};
        data.fullName = name.trim();
        localStorage.setItem('userInfo', JSON.stringify(data));
      } catch {}

      f7.dialog.close();
      f7.dialog.alert('Full name updated.', '', () => {
        f7.views.main.router.back();
      });
    } catch (err) {
      f7.dialog.close();
      console.error('Error updating full name', err);
      f7.dialog.alert('Error updating full name.');
    }
  };

  return (
    <Page name="account-name">
      <Navbar className="no-outline">
        <NavLeft>
          <Link back className="cancel-button">Cancel</Link>
        </NavLeft>
        <NavTitle>Edit name</NavTitle>
        <NavRight>
          <Link className="save-button" onClick={handleSave}>
            Save
          </Link>
        </NavRight>
      </Navbar>

      <form
        className="login-form change-password-form"
        onSubmit={(e) => e.preventDefault()}>
        <label htmlFor="full-name">Full name</label>
        <input
          id="full-name"
          type="text"
          placeholder="Enter full name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </form>
    </Page>
  );
}

export default AccountNamePage;
